$(document).on("turbolinks:load", () => {
  $(".header__toggle").on("click", (event) => {
    if ($("#header__sidebar").hasClass("header__active-menu")) {
      $("#header__sidebar").removeClass("header__active-menu");
    } else {
      $("#header__sidebar").addClass("header__active-menu");
    }
  });
});
